import React, { Fragment, useContext } from "react";
import { useHistory } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import AuthContext from "../../context/auth/AuthContext";
import CardContext from "../../context/card/CardContext";
import NavigationContext from "../../context/navigation/NavigationContext";
// import ConfigContext from "../../context/config/ConfigContext";
import Preloader from "./../layout/Preloader";
import ActionMenu from "./../layout/ActionMenu";
import Moment from "react-moment";
import "moment-timezone";
import usePageTitle from "../../hooks/usePageTitle";
import { env } from "../../env";

const OrderDetails = (props) => {
  const authContext = useContext(AuthContext);
  const { user } = authContext;
  const cardContext = useContext(CardContext);
  const { orderLoading, selectedOrder } = cardContext;
  // const configContext = useContext(ConfigContext);
  // const { getConfigValue } = configContext;
  const navigationContext = useContext(NavigationContext);
  const { setNavigationPage } = navigationContext;
  const order = selectedOrder;
  const history = useHistory();

  const backToHome = () => {
    setNavigationPage("Order");
    history.goBack();
  };

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Order Detail",
  });

  return (
    <Fragment>
      {orderLoading && <Preloader />}
      <ActionMenu resetUseIdleTimer={props.resetUseIdleTimer} />
      <div
        className="patronHome"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <div id="pageHeader" className="pageTitle patronHome__pageTitle">
          ORDER DETAILS
        </div>
        <div className="CardItem">
          <Row>
            <Col className="CardItem__cardTitle">ORDER DETAILS</Col>
          </Row>
          <Row className="CardItem__cardTitle__cardItems">
            <Col lg={12}>
              <Row className="CardItem__cardTitle__lineItem">
                <Col lg="5"> Order Number:</Col>
                <Col>
                  <strong>{order.id}</strong>
                </Col>
              </Row>
              <Row className="CardItem__cardTitle__lineItem">
                <Col lg="5"> Order Date:</Col>
                <Col>
                  <strong>
                    <Moment
                      format="MM/DD/YYYY hh:mm A"
                      tz={env.REACT_APP_HMW_TIME_ZONE}
                    >
                      {order.creationDate}
                    </Moment>
                  </strong>
                </Col>
              </Row>
              <Row className="CardItem__cardTitle__lineItem">
                <Col lg="5">Order Amount: </Col>
                <Col>
                  <strong>${(order.price / 100).toFixed(2)}</strong>
                </Col>
              </Row>
              <Row className="CardItem__cardTitle__lineItem">
                <Col lg="5">Order Status:</Col>
                <Col>
                  <strong>{order.status}</strong>
                </Col>
              </Row>
              <Row className="CardItem__cardTitle__lineItem">
                <Col lg="5">Payment Type: </Col>
                <Col>
                  <strong>{order.methodOfPayment}</strong>
                </Col>
              </Row>
              {user && !user.sponsor && (
                <Fragment>
                  <Row className="CardItem__cardTitle__lineItem">
                    <Col lg="5">Payment Authorization Code: </Col>
                    <Col>
                      <strong>{order.authorizationId}</strong>
                    </Col>
                  </Row>
                  <Row className="CardItem__cardTitle__lineItem">
                    <Col lg="5">Payment Transaction Id: </Col>
                    <Col>
                      <strong>{order.transactionId}</strong>
                    </Col>
                  </Row>
                  <Row className="CardItem__cardTitle__lineItem">
                    <Col lg="5">Payment Information: </Col>
                    <Col>
                      <span className="multiline-text">
                        <strong>{order.paymentDescription}</strong>
                      </span>
                    </Col>
                  </Row>
                </Fragment>
              )}
            </Col>
          </Row>
        </div>
        <div className="CardItem ">
          <Row>
            <Col lg="6" className="CardItem__cardTitle">
              DESCRIPTION
            </Col>
            <Col lg="4" className="CardItem__cardTitle">
              ITEM STATUS
            </Col>
            <Col lg="2" className="CardItem__cardTitle">
              PRICE
            </Col>
          </Row>
          {order.orderItems &&
            order.orderItems.map((item) => (
              <Fragment>
                <Row className="CardItem__cardTitle__lineItem">
                  <Col lg="6"> {item.description} </Col>
                  <Col lg="4">{item.status}</Col>
                  <Col lg="2"> ${(item.price / 100).toFixed(2)} </Col>
                </Row>
              </Fragment>
            ))}
        </div>
        <div id="pageAction" className="patronHome__actionPanel">
          <button
            aria-label="Back "
            name="backHome"
            className="btn btn-primary patronHome__actionPanel__button"
            onClick={backToHome}
          >
            Back
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default OrderDetails;
